export  const appDropdown = [
    {value: "1", label: "PENDING" },
    // {value: "2", label: "REVISI"}, 
    {value: "3", label: "REJECT"},
    {value: "4", label: "APPROVE"},
]